var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70893 11.5903L9.50278 17.033C9.64793 17.1694 9.7205 17.2376 9.79942 17.2721C9.9273 17.3282 10.0728 17.3282 10.2007 17.2721C10.2796 17.2376 10.3522 17.1694 10.4973 17.033L16.2911 11.5903C17.9213 10.059 18.1192 7.539 16.7482 5.77189L16.4904 5.43961C14.8503 3.32565 11.5581 3.68018 10.4056 6.09487C10.2428 6.43596 9.75728 6.43596 9.59448 6.09487C8.44202 3.68017 5.14981 3.32565 3.50966 5.43962L3.25186 5.77189C1.88083 7.539 2.07879 10.059 3.70893 11.5903Z",
    fill: "#EE6955",
    stroke: "#EE6955",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFill);
export default __webpack_public_path__ + "static/media/favorite_fill.2d0fb1eec5019bffc02a3388c74c6a93.svg";
export { ForwardRef as ReactComponent };